import emailjs from 'emailjs-com';
import { STORE_LOGO_URL, buildOrderConfirmationHtml } from './orderEmailTemplate';

const EMAIL_FUNCTION_URL =
  process.env.REACT_APP_EMAIL_FUNCTION_URL ||
  'https://europe-west1-vinogenes-5207a.cloudfunctions.net/sendOrderConfirmation';

async function sendViaCloudFunction(order) {
  const response = await fetch(EMAIL_FUNCTION_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ order })
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok || !data.success) {
    throw new Error(data.error || 'No se pudo enviar el email de confirmación');
  }

  return data;
}

async function sendViaEmailJS(order) {
  const SERVICE_ID = 'service_cv3ipjj';
  const TEMPLATE_ID = 'template_9p9nl8b';
  const USER_ID = 'WfaZaixQhCGODh509';

  const templateParams = {
    email: order.shippingAddress?.email || order.customerEmail,
    to_name: order.shippingAddress?.name || order.customerName,
    order_id: order.id,
    logo_url: STORE_LOGO_URL,
    html_message: buildOrderConfirmationHtml(order),
    orders: order.items.map((item) => ({
      name: item.wineName,
      units: item.quantity,
      price: item.price.toFixed(2)
    })),
    cost: {
      shipping: order.shipping?.toFixed(2) || '0.00',
      tax: (order.tax || 0).toFixed(2),
      total: order.total?.toFixed(2) || '0.00'
    }
  };

  return emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, USER_ID);
}

export const sendOrderConfirmationEmail = async (order) => {
  try {
    return await sendViaCloudFunction(order);
  } catch (cloudError) {
    console.warn('Email vía Cloud Function falló, usando EmailJS:', cloudError.message);
    return sendViaEmailJS(order);
  }
};
